// Crypto (token) sub-module of the wallet module.
//
// Owns: token wallet activation, trustline setup, on-chain balance display,
// recent token transactions. Currently placeholders — the actual token-wallet
// SDK integration lands in a future PR.
//
// This is INTERNAL to the wallet parent. Other modules consume the wallet
// public surface (`@modules/wallets`), never `@modules/wallets/crypto` directly.
import type { RouteRecordRaw } from 'vue-router'

export { default as TokenWalletContainer } from './containers/TokenWalletContainer.vue'

// No dedicated routes yet — token wallet lives inside the /wallet tab shell.
// This export lets the parent aggregate routes uniformly across submodules.
export const cryptoWalletRoutes: RouteRecordRaw[] = []
